import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { InviteService } from '../../features/classes/services/invite.service';
import { AuthService } from '../services/auth/auth.service';

/**
 * Guard for student view routes.
 * Allows both students and teachers with enrollments.
 * Also processes any pending invite tokens for students.
 */
export const studentGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const inviteService = inject(InviteService);

  // Wait for user to be loaded
  const user = await firstValueFrom(auth.$user);

  if (!user) {
    // Not authenticated
    router.navigate(['/signin']);
    return false;
  }

  // Process any pending invites for students
  if (user.user_type === 'student' && inviteService.hasPendingInvite()) {
    await inviteService.acceptPendingInvite();
  }

  // Both students and teachers can access student view
  // Teachers see it for classes they're enrolled in
  return true;
};
